var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowDownSd = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.6769 4.70088C24.5909 3.17788 23.4939 1.22888 21.7099 1.22888H2.29592C0.511915 1.22888 -0.585085 3.17788 0.328915 4.70088L10.0379 20.8809C10.9289 22.3639 13.0789 22.3609 13.9679 20.8809L23.6769 4.70088Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "none"
})))));
export default SvgIconArrowDownSd;